function useProcessSchema() {
    
    function processSchema(schema: any, element: any) {
        let processedSchema = {...schema}; // Duplicamos el esquema para no modificar el original
        
        // Si el elemento tiene _readOnly, aplicar readOnly a todas las propiedades
        const isReadOnly = element && element._readOnly === true;
        
        // Recorremos todas las propiedades del esquema
        Object.keys(processedSchema.properties).forEach((key) => {
            let property = processedSchema.properties[key];
            
            // Aplicar readOnly si está marcado, o eliminarlo si no
            if (isReadOnly) {
                property.readOnly = true;
            } else {
                delete property.readOnly;
            }
            
            // Si la propiedad tiene la propiedad 'show'
            if (property.hasOwnProperty('show')) {
                // Si show es una función, la ejecutamos pasandole el element
                if (typeof property.show === 'function') {
                    property.show = property.show(element);
                } else {
                    if (!property.show) { // Si 'show' es falso, eliminamos la propiedad del esquema
                        element[key] = property.default;
                        delete processedSchema.properties[key];
                    } 
                    // Si 'show' es verdadero, eliminamos la propiedad 'show' del esquema
                    else {
                        delete property.show;
                    }
                }
            }
            
            // Si la propiedad es un objeto, aplicamos la recursividad
            if (processedSchema.properties[key] && property.type === 'object' && property.properties) {
                processedSchema.properties[key] = processSchema(property, element[key] || {});
            }

            // Si la propiedad es un array de objetos, aplicamos la recursividad a cada elemento
            if (element && processedSchema.properties[key] && property.type === 'array' && property.items && property.items.type === 'object' && property.items.properties) {
                let items = property.items;
                let newElement = element[key] ? element[key] : {};
                
                // Aplicar readOnly a items del array si está marcado, o eliminarlo si no
                if (items.properties) {
                    Object.keys(items.properties).forEach((itemKey) => {
                        if (isReadOnly) {
                            items.properties[itemKey].readOnly = true;
                        } else {
                            delete items.properties[itemKey].readOnly;
                        }
                    });
                }
                
                processedSchema.properties[key].items = processSchema(items, newElement);
            }
        });
        
        return processedSchema;
    }
    
    return (schema: any, element: any) => {
        return processSchema(schema, element);
    }
}

export default useProcessSchema;
